import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import shawnPortrait from "@/assets/shawn-portrait.png";

export const FounderIntro = () => (
  <section data-testid="founder-section" className="bg-[#FBF8F1] py-16 md:py-24">
    <div className="container-lr grid items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative order-1 lg:order-none"
      >
        <div className="relative rounded-card bg-gradient-to-br from-[#C5A15A] via-[#BE9A50] to-[#A9863F] p-3.5 shadow-[0_30px_60px_-40px_rgba(17,17,17,0.5)]">
          <div className="overflow-hidden rounded-[0.8rem] border border-white/25">
            <img
              src={shawnPortrait}
              alt="Shawn King, founder of Legacy Life & Retirement"
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
        <span aria-hidden="true" className="absolute -bottom-3 -right-3 hidden h-16 w-16 rounded-br-card border-b border-r border-gold/70 md:block" />
      </motion.div>

      <div>
        <div className="flex items-center gap-4">
          <span className="gold-rule" />
          <p className="eyebrow">Meet Shawn King</p>
        </div>
        <h2 className="section-heading mt-6 text-legacy">
          Financial education should feel understandable, <span className="accent-word">practical</span>, and <span className="accent-word">personal</span>.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate md:text-lg">
          Shawn King founded Legacy Life &amp; Retirement to help ordinary families gain the understanding, structure, and confidence needed to create extraordinary lives. His approach is centered on education first, coordinated financial systems, and helping people understand why each decision is being made before they implement it.
        </p>
        <div className="mt-8">
          <Link to="/about" data-testid="founder-cta" className="btn-base btn-outline-dark">
            Meet Shawn <ArrowRight size={17} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
